export const DEVICE_HASH_COLUMN = 'DEVICE_HASH';

export const RETARGETING_CSV_COLUMN_OPTIONS = Object.freeze([
  { label: 'Device Hash (SHA-256)', value: DEVICE_HASH_COLUMN, default: true, locked: true },
  { label: 'Inventory (Frame / Asset) Ref', value: 'INVENTORY_REF' },
  { label: 'Inventory Class', value: 'INVENTORY_CLASS' },
  { label: 'Inventory Type', value: 'INVENTORY_TYPE' },
  { label: 'Inventory Subtype', value: 'INVENTORY_SUBTYPE', note: 'Stationary inventory only' },
  { label: 'Media Product', value: 'MEDIA_PRODUCT', note: 'Transit inventory only' },
  { label: 'Ad Group', value: 'AD_GROUP' },
  { label: 'Inventory Format (Static/Digital)', value: 'INVENTORY_FORMAT' },
  { label: 'Market ID', value: 'MARKET_ID' },
  { label: 'Flight ID (Placement)', value: 'FLIGHT_ID' },
  { label: 'Creative ID', value: 'CREATIVE_ID' },
  { label: 'Exposure Timestamp', value: 'TIMESTAMP' },
  { label: 'DMA Code', value: 'DMA_CODE' },
  { label: 'DMA Name (Market)', value: 'DMA_NAME' },
]);

export function getRetargetingCsvColumnsInOrder(columns, includeDeviceHash = true) {
  const selectedColumns = new Set(Array.isArray(columns) ? columns : []);

  if (includeDeviceHash) {
    selectedColumns.add(DEVICE_HASH_COLUMN);
  }

  return RETARGETING_CSV_COLUMN_OPTIONS
    .map(column => column.value)
    .filter(column => selectedColumns.has(column));
}

export function hasEventLevelRetargetingColumns(columns) {
  return getRetargetingCsvColumnsInOrder(columns).some(column => column !== DEVICE_HASH_COLUMN);
}
